import _ from 'lodash';
import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { PendingService } from '../services/pending.service';
import { catchError, tap } from 'rxjs/operators';
import { LoadingService } from 'app/core/services/loading.service';
import { DialogService } from 'app/dialog/services/dialog.service';


@Component({
  selector: 'app-updating-cart-component',
  templateUrl: './updating-cart-component.component.html',
  styleUrls: ['./updating-cart-component.component.scss']
})
export class UpdatingCartComponentComponent implements OnInit {

  @Input() id = '';
  @Input() cartid =''
  @Input() donorid = '';
  @Input() eventid = '';
  @Input() campaignid = ''
  @Input() email = ''
  @Input() veventid = '';


  constructor(    
    public pendingService: PendingService,   
     public store: Store,
     public loadingService: LoadingService,
     private dialogService: DialogService
  ) { }
  public list = [];
  ngOnInit(): void {
  }

  onClickUpadateEmail(elem){
    const vEventId = elem.veventid;
    const eventId = elem.eventid;

    const emailFrom = elem.email;
    const donorId = elem.donorid;
    const cartId = elem.cartid;
    const campaignId = elem.campaignid;

    const action = DialogActions.openDialog({
      payload: {
        name: "updateCart",
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-update-cart',
          containerClass:'mdb-modal-backdrop-paybee'
        },
        initialState: {
          cartID: cartId,
          email: emailFrom,
          callback: (data) => {
            if(vEventId){
              data.vEventId = vEventId;
            }
            if(eventId){
              data.eventId = eventId;
            }

            data.emailFrom = emailFrom;
            data.donorId = donorId;
            data.cartId = cartId;
            data.campaignId = campaignId;

            if(data.status == true) {
              window['orgMain'].updateDonorCart(data)            
            }
          }
        },

      }
    });
    this.store.dispatch(action);
  }
  ngOnDestroy(): void {
    this.id = '';
    this.cartid =''
    this.donorid = '';
    this.eventid = '';
    this.campaignid = '';
  }
  
}
